import "core-js/modules/es.array.push.js";
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2ce1f33c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "trading-view"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "time"
};
const _hoisted_5 = {
  class: "indicator"
};
const _hoisted_6 = {
  class: "chart-icon"
};
const _hoisted_7 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M17 11v6h3v-6h-3zm-.5-1h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5z"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M18 7h1v3.5h-1zm0 10.5h1V21h-1z"
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M9 8v12h3V8H9zm-.5-1h4a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5z"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M10 4h1v3.5h-1zm0 16.5h1V24h-1z"
}, null, -1));
const _hoisted_12 = [_hoisted_8, _hoisted_9, _hoisted_10, _hoisted_11];
const _hoisted_13 = {
  class: "chart-icon"
};
const _hoisted_14 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M17 11v6h3v-6h-3zm-.5-1h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5z"
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M18 7h1v3.5h-1zm0 10.5h1V21h-1z"
}, null, -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M9 8v12h3V8H9zm-.5-1h4a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5z"
}, null, -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M10 4h1v3.5h-1zm0 16.5h1V24h-1z"
}, null, -1));
const _hoisted_19 = [_hoisted_15, _hoisted_16, _hoisted_17, _hoisted_18];
const _hoisted_20 = {
  class: "chart-icon"
};
const _hoisted_21 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M17 11v6h3v-6h-3zm-.5-1h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5z"
}, null, -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M18 7h1v3.5h-1zm0 10.5h1V21h-1z"
}, null, -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M9 8v11h3V8H9zm-.5-1h4a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 .5-.5z"
}, null, -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M10 4h1v5h-1zm0 14h1v5h-1zM8.5 9H10v1H8.5zM11 9h1.5v1H11zm-1 1h1v1h-1zm-1.5 1H10v1H8.5zm2.5 0h1.5v1H11zm-1 1h1v1h-1zm-1.5 1H10v1H8.5zm2.5 0h1.5v1H11zm-1 1h1v1h-1zm-1.5 1H10v1H8.5zm2.5 0h1.5v1H11zm-1 1h1v1h-1zm-1.5 1H10v1H8.5zm2.5 0h1.5v1H11z"
}, null, -1));
const _hoisted_26 = [_hoisted_22, _hoisted_23, _hoisted_24, _hoisted_25];
const _hoisted_27 = {
  class: "chart-icon"
};
const _hoisted_28 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m25.39 7.31-8.83 10.92-6.02-5.47-7.16 8.56-.76-.64 7.82-9.36 6 5.45L24.61 6.7l.78.62Z"
}, null, -1));
const _hoisted_30 = [_hoisted_29];
const _hoisted_31 = {
  class: "chart-icon"
};
const _hoisted_32 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "m18.43 15.91 6.96-8.6-.78-.62-6.96 8.6a2.49 2.49 0 0 0-2.63.2l-2.21-2.02A2.5 2.5 0 0 0 10.5 10a2.5 2.5 0 1 0 1.73 4.3l2.12 1.92a2.5 2.5 0 1 0 4.08-.31ZM10.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm7.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
}, null, -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M8.37 13.8c.17.3.4.54.68.74l-5.67 6.78-.76-.64 5.75-6.88Z"
}, null, -1));
const _hoisted_35 = [_hoisted_33, _hoisted_34];
const _hoisted_36 = {
  class: "chart-icon"
};
const _hoisted_37 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M19 5h5v1h-4v13h-6v-7h-4v12H5v-1h4V11h6v7h4V5Z"
}, null, -1));
const _hoisted_39 = [_hoisted_38];
const _hoisted_40 = {
  class: "chart-icon"
};
const _hoisted_41 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m25.35 5.35-9.5 9.5-.35.36-.35-.36-4.65-4.64-8.15 8.14-.7-.7 8.5-8.5.35-.36.35.36 4.65 4.64 9.15-9.14.7.7ZM2 21h1v1H2v-1Zm2-1H3v1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1V9h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v1H9v1H8v1H7v1H6v1H5v1H4v1Zm1 0v1H4v-1h1Zm1 0H5v-1h1v1Zm1 0v1H6v-1h1Zm0-1H6v-1h1v1Zm1 0H7v1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v1H9v1H8v1H7v1h1v1Zm1 0v1H8v-1h1Zm0-1H8v-1h1v1Zm1 0H9v1h1v1h1v-1h1v1h1v-1h1v1h1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v1H9v1h1v1Zm1 0v1h-1v-1h1Zm0-1v-1h-1v1h1Zm0 0v1h1v1h1v-1h-1v-1h-1Zm6 2v-1h1v1h-1Zm2 0v1h-1v-1h1Zm0-1h-1v-1h1v1Zm1 0h-1v1h1v1h1v-1h1v1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v1h-1v1h-1v1h-1v1h1v1Zm1 0h-1v1h1v-1Zm0-1h1v1h-1v-1Zm0-1h1v-1h-1v1Zm0 0v1h-1v-1h1Zm-4 3v1h-1v-1h1Z"
}, null, -1));
const _hoisted_43 = [_hoisted_42];
const _hoisted_44 = {
  class: "chart-icon"
};
const _hoisted_45 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22 3h1v1h-1V3Zm0 2V4h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1V9h-1V8h-1V7h-1V6h-1V5h-1v1H9v1H8v1H7v1H6v1H5v1H4v1h1v1H4v1h1v-1h1v-1h1v-1h1v-1h1V9h1V8h1v1h1v1h1v1h1v1h1v1h1v-1h1v-1h1v-1h1V9h1V8h1V7h1V6h1V5h-1Zm-1 1V5h1v1h-1Zm-1 1V6h1v1h-1Zm-1 1V7h1v1h-1Zm-1 1V8h1v1h-1Zm-1 1V9h1v1h-1Zm-1 1v-1h1v1h-1Zm-1 0v-1h-1V9h-1V8h-1V7h-1V6h-1v1H9v1H8v1H7v1H6v1H5v1h1v-1h1v-1h1V9h1V8h1V7h1v1h1v1h1v1h1v1h1Zm0 0h1v1h-1v-1Zm.84 6.37 7.5-7-.68-.74-7.15 6.67-4.66-4.65-.33-.34-.36.32-5.5 5 .68.74 5.14-4.68 4.67 4.66.34.35.35-.33ZM6 23H5v1h1v-1Zm0-1H5v-1h1v1Zm1 0v1H6v-1h1Zm0-1H6v-1h1v1Zm1 0v1H7v-1h1Zm0-1H7v-1h1v1Zm1 0v1H8v-1h1Zm0-1H8v-1h1v1Zm1 0v1H9v-1h1Zm0-1H9v-1h1v1Zm1 0h-1v1h1v1h1v1h1v1h1v1h1v1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h-1v-1h1v-1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v1h1v1Zm0 0h1v1h-1v-1Zm2 2v1h1v1h1v1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1Zm0 0v-1h-1v1h1Z"
}, null, -1));
const _hoisted_47 = [_hoisted_46];
const _hoisted_48 = {
  class: "chart-icon"
};
const _hoisted_49 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m10.49 7.55-.42.7-2.1 3.5.86.5 1.68-2.8 1.8 2.82.84-.54-2.23-3.5-.43-.68Zm12.32 4.72-.84-.54 2.61-4 .84.54-2.61 4Zm-5.3 6.3 1.2-1.84.84.54-1.63 2.5-.43.65-.41-.65-1.6-2.5.85-.54 1.17 1.85ZM4.96 16.75l.86.52-2.4 4-.86-.52 2.4-4ZM3 14v1h1v-1H3Zm2 0h1v1H5v-1Zm2 0v1h1v-1H7Zm2 0h1v1H9v-1Zm2 0v1h1v-1h-1Zm2 0h1v1h-1v-1Zm2 0v1h1v-1h-1Zm2 0h1v1h-1v-1Zm2 0v1h1v-1h-1Zm2 0h1v1h-1v-1Zm2 0v1h1v-1h-1Zm2 0h1v1h-1v-1Z"
}, null, -1));
const _hoisted_51 = [_hoisted_50];
const _hoisted_52 = {
  class: "chart-icon"
};
const _hoisted_53 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12 7v14h5V7h-5Zm4 1h-3v12h3V8ZM19 15v6h5v-6h-5Zm4 1h-3v4h3v-4ZM5 12h5v9H5v-9Zm1 1h3v7H6v-7Z"
}, null, -1));
const _hoisted_55 = [_hoisted_54];
const _hoisted_56 = {
  class: "chart-icon"
};
const _hoisted_57 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.5 7H7v14h5V7H7.5zM8 20V8h3v12H8zm7.5-11H15v10h5V9h-4.5zm.5 9v-8h3v8h-3z"
}, null, -1));
const _hoisted_59 = [_hoisted_58];
const _hoisted_60 = {
  class: "chart-icon"
};
const _hoisted_61 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M9 8v12h3V8H9zm-1-.502C8 7.223 8.215 7 8.498 7h4.004c.275 0 .498.22.498.498v13.004a.493.493 0 0 1-.498.498H8.498A.496.496 0 0 1 8 20.502V7.498z"
}, null, -1));
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M10 4h1v3.5h-1z"
}, null, -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M17 6v6h3V6h-3zm-1-.5c0-.276.215-.5.498-.5h4.004c.275 0 .498.23.498.5v7c0 .276-.215.5-.498.5h-4.004a.503.503 0 0 1-.498-.5v-7z"
}, null, -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M18 2h1v3.5h-1z"
}, null, -1));
const _hoisted_66 = [_hoisted_62, _hoisted_63, _hoisted_64, _hoisted_65];
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28"
}, [/*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "square"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M10.5 7.5v15M7.5 20.5H10M13.5 11.5H11M19.5 6.5v15M16.5 9.5H19M22.5 16.5H20"
})])], -1));
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bars", -1));
const _hoisted_69 = [_hoisted_67, _hoisted_68];
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M17 11v6h3v-6h-3zm-.5-1h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5z"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M18 7h1v3.5h-1zm0 10.5h1V21h-1z"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M9 8v12h3V8H9zm-.5-1h4a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5z"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M10 4h1v3.5h-1zm0 16.5h1V24h-1z"
})], -1));
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Candles", -1));
const _hoisted_72 = [_hoisted_70, _hoisted_71];
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M17 11v6h3v-6h-3zm-.5-1h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5z"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M18 7h1v3.5h-1zm0 10.5h1V21h-1z"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M9 8v11h3V8H9zm-.5-1h4a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-12a.5.5 0 0 1 .5-.5z"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M10 4h1v5h-1zm0 14h1v5h-1zM8.5 9H10v1H8.5zM11 9h1.5v1H11zm-1 1h1v1h-1zm-1.5 1H10v1H8.5zm2.5 0h1.5v1H11zm-1 1h1v1h-1zm-1.5 1H10v1H8.5zm2.5 0h1.5v1H11zm-1 1h1v1h-1zm-1.5 1H10v1H8.5zm2.5 0h1.5v1H11zm-1 1h1v1h-1zm-1.5 1H10v1H8.5zm2.5 0h1.5v1H11z"
})], -1));
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hollow candles", -1));
const _hoisted_75 = [_hoisted_73, _hoisted_74];
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28"
}, [/*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m25.39 7.31-8.83 10.92-6.02-5.47-7.16 8.56-.76-.64 7.82-9.36 6 5.45L24.61 6.7l.78.62Z"
})], -1));
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Line", -1));
const _hoisted_78 = [_hoisted_76, _hoisted_77];
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "m18.43 15.91 6.96-8.6-.78-.62-6.96 8.6a2.49 2.49 0 0 0-2.63.2l-2.21-2.02A2.5 2.5 0 0 0 10.5 10a2.5 2.5 0 1 0 1.73 4.3l2.12 1.92a2.5 2.5 0 1 0 4.08-.31ZM10.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm7.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M8.37 13.8c.17.3.4.54.68.74l-5.67 6.78-.76-.64 5.75-6.88Z"
})], -1));
const _hoisted_80 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Line with markers", -1));
const _hoisted_81 = [_hoisted_79, _hoisted_80];
const _hoisted_82 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M19 5h5v1h-4v13h-6v-7h-4v12H5v-1h4V11h6v7h4V5Z"
})], -1));
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Step line", -1));
const _hoisted_84 = [_hoisted_82, _hoisted_83];
const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28"
}, [/*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m25.35 5.35-9.5 9.5-.35.36-.35-.36-4.65-4.64-8.15 8.14-.7-.7 8.5-8.5.35-.36.35.36 4.65 4.64 9.15-9.14.7.7ZM2 21h1v1H2v-1Zm2-1H3v1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1V9h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v1H9v1H8v1H7v1H6v1H5v1H4v1Zm1 0v1H4v-1h1Zm1 0H5v-1h1v1Zm1 0v1H6v-1h1Zm0-1H6v-1h1v1Zm1 0H7v1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v1H9v1H8v1H7v1h1v1Zm1 0v1H8v-1h1Zm0-1H8v-1h1v1Zm1 0H9v1h1v1h1v-1h1v1h1v-1h1v1h1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v1H9v1h1v1Zm1 0v1h-1v-1h1Zm0-1v-1h-1v1h1Zm0 0v1h1v1h1v-1h-1v-1h-1Zm6 2v-1h1v1h-1Zm2 0v1h-1v-1h1Zm0-1h-1v-1h1v1Zm1 0h-1v1h1v1h1v-1h1v1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v1h-1v1h-1v1h-1v1h1v1Zm1 0h-1v1h1v-1Zm0-1h1v1h-1v-1Zm0-1h1v-1h-1v1Zm0 0v1h-1v-1h1Zm-4 3v1h-1v-1h1Z"
})], -1));
const _hoisted_86 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Area", -1));
const _hoisted_87 = [_hoisted_85, _hoisted_86];
const _hoisted_88 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22 3h1v1h-1V3Zm0 2V4h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1V9h-1V8h-1V7h-1V6h-1V5h-1v1H9v1H8v1H7v1H6v1H5v1H4v1h1v1H4v1h1v-1h1v-1h1v-1h1v-1h1V9h1V8h1v1h1v1h1v1h1v1h1v1h1v-1h1v-1h1v-1h1V9h1V8h1V7h1V6h1V5h-1Zm-1 1V5h1v1h-1Zm-1 1V6h1v1h-1Zm-1 1V7h1v1h-1Zm-1 1V8h1v1h-1Zm-1 1V9h1v1h-1Zm-1 1v-1h1v1h-1Zm-1 0v-1h-1V9h-1V8h-1V7h-1V6h-1v1H9v1H8v1H7v1H6v1H5v1h1v-1h1v-1h1V9h1V8h1V7h1v1h1v1h1v1h1v1h1Zm0 0h1v1h-1v-1Zm.84 6.37 7.5-7-.68-.74-7.15 6.67-4.66-4.65-.33-.34-.36.32-5.5 5 .68.74 5.14-4.68 4.67 4.66.34.35.35-.33ZM6 23H5v1h1v-1Zm0-1H5v-1h1v1Zm1 0v1H6v-1h1Zm0-1H6v-1h1v1Zm1 0v1H7v-1h1Zm0-1H7v-1h1v1Zm1 0v1H8v-1h1Zm0-1H8v-1h1v1Zm1 0v1H9v-1h1Zm0-1H9v-1h1v1Zm1 0h-1v1h1v1h1v1h1v1h1v1h1v1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h-1v-1h1v-1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v1h1v1Zm0 0h1v1h-1v-1Zm2 2v1h1v1h1v1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1Zm0 0v-1h-1v1h1Z"
})], -1));
const _hoisted_89 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "HLC area", -1));
const _hoisted_90 = [_hoisted_88, _hoisted_89];
const _hoisted_91 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28"
}, [/*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m10.49 7.55-.42.7-2.1 3.5.86.5 1.68-2.8 1.8 2.82.84-.54-2.23-3.5-.43-.68Zm12.32 4.72-.84-.54 2.61-4 .84.54-2.61 4Zm-5.3 6.3 1.2-1.84.84.54-1.63 2.5-.43.65-.41-.65-1.6-2.5.85-.54 1.17 1.85ZM4.96 16.75l.86.52-2.4 4-.86-.52 2.4-4ZM3 14v1h1v-1H3Zm2 0h1v1H5v-1Zm2 0v1h1v-1H7Zm2 0h1v1H9v-1Zm2 0v1h1v-1h-1Zm2 0h1v1h-1v-1Zm2 0v1h1v-1h-1Zm2 0h1v1h-1v-1Zm2 0v1h1v-1h-1Zm2 0h1v1h-1v-1Zm2 0v1h1v-1h-1Zm2 0h1v1h-1v-1Z"
})], -1));
const _hoisted_92 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Baseline", -1));
const _hoisted_93 = [_hoisted_91, _hoisted_92];
const _hoisted_94 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28"
}, [/*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12 7v14h5V7h-5Zm4 1h-3v12h3V8ZM19 15v6h5v-6h-5Zm4 1h-3v4h3v-4ZM5 12h5v9H5v-9Zm1 1h3v7H6v-7Z"
})], -1));
const _hoisted_95 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Columns", -1));
const _hoisted_96 = [_hoisted_94, _hoisted_95];
const _hoisted_97 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28"
}, [/*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.5 7H7v14h5V7H7.5zM8 20V8h3v12H8zm7.5-11H15v10h5V9h-4.5zm.5 9v-8h3v8h-3z"
})], -1));
const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "High-low", -1));
const _hoisted_99 = [_hoisted_97, _hoisted_98];
const _hoisted_100 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  width: "28",
  height: "28",
  fill: "currentColor"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M9 8v12h3V8H9zm-1-.502C8 7.223 8.215 7 8.498 7h4.004c.275 0 .498.22.498.498v13.004a.493.493 0 0 1-.498.498H8.498A.496.496 0 0 1 8 20.502V7.498z"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M10 4h1v3.5h-1z"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M17 6v6h3V6h-3zm-1-.5c0-.276.215-.5.498-.5h4.004c.275 0 .498.23.498.5v7c0 .276-.215.5-.498.5h-4.004a.503.503 0 0 1-.498-.5v-7z"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M18 2h1v3.5h-1z"
})], -1));
const _hoisted_101 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Heikin Ashi", -1));
const _hoisted_102 = [_hoisted_100, _hoisted_101];
const _hoisted_103 = {
  class: "chart-icon"
};
const _hoisted_104 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  d: "M20 17l-5 5M15 17l5 5M9 11.5h7M17.5 8a2.5 2.5 0 0 0-5 0v11a2.5 2.5 0 0 1-5 0"
}, null, -1));
const _hoisted_105 = [_hoisted_104];
const _hoisted_106 = {
  class: "right"
};
const _hoisted_107 = {
  class: "indicator"
};
const _hoisted_108 = {
  class: "chart-icon"
};
const _hoisted_109 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  fill: "currentColor",
  "fill-rule": "evenodd"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "nonzero",
  d: "M14 17a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M5.005 16A1.003 1.003 0 0 1 4 14.992v-1.984A.998.998 0 0 1 5 12h1.252a7.87 7.87 0 0 1 .853-2.06l-.919-.925c-.356-.397-.348-1 .03-1.379l1.42-1.42a1 1 0 0 1 1.416.007l.889.882A7.96 7.96 0 0 1 12 6.253V5c0-.514.46-1 1-1h2c.557 0 1 .44 1 1v1.253a7.96 7.96 0 0 1 2.06.852l.888-.882a1 1 0 0 1 1.416-.006l1.42 1.42a.999.999 0 0 1 .029 1.377s-.4.406-.918.926a7.87 7.87 0 0 1 .853 2.06H23c.557 0 1 .447 1 1.008v1.984A.998.998 0 0 1 23 16h-1.252a7.87 7.87 0 0 1-.853 2.06l.882.888a1 1 0 0 1 .006 1.416l-1.42 1.42a1 1 0 0 1-1.415-.007l-.889-.882a7.96 7.96 0 0 1-2.059.852v1.248c0 .56-.45 1.005-1.008 1.005h-1.984A1.004 1.004 0 0 1 12 22.995v-1.248a7.96 7.96 0 0 1-2.06-.852l-.888.882a1 1 0 0 1-1.416.006l-1.42-1.42a1 1 0 0 1 .007-1.415l.882-.888A7.87 7.87 0 0 1 6.252 16H5.005zm3.378-6.193l-.227.34A6.884 6.884 0 0 0 7.14 12.6l-.082.4H5.005C5.002 13 5 13.664 5 14.992c0 .005.686.008 2.058.008l.082.4c.18.883.52 1.71 1.016 2.453l.227.34-1.45 1.46c-.004.003.466.477 1.41 1.422l1.464-1.458.34.227a6.959 6.959 0 0 0 2.454 1.016l.399.083v2.052c0 .003.664.005 1.992.005.005 0 .008-.686.008-2.057l.399-.083a6.959 6.959 0 0 0 2.454-1.016l.34-.227 1.46 1.45c.003.004.477-.466 1.422-1.41l-1.458-1.464.227-.34A6.884 6.884 0 0 0 20.86 15.4l.082-.4h2.053c.003 0 .005-.664.005-1.992 0-.005-.686-.008-2.058-.008l-.082-.4a6.884 6.884 0 0 0-1.016-2.453l-.227-.34 1.376-1.384.081-.082-1.416-1.416-1.465 1.458-.34-.227a6.959 6.959 0 0 0-2.454-1.016L15 7.057V5c0-.003-.664-.003-1.992 0-.005 0-.008.686-.008 2.057l-.399.083a6.959 6.959 0 0 0-2.454 1.016l-.34.227-1.46-1.45c-.003-.004-.477.466-1.421 1.408l1.457 1.466z"
})], -1));
const _hoisted_110 = [_hoisted_109];
const _hoisted_111 = {
  class: "chart-icon"
};
const _hoisted_112 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M8.5 6A2.5 2.5 0 0 0 6 8.5V11h1V8.5C7 7.67 7.67 7 8.5 7H11V6H8.5zM6 17v2.5A2.5 2.5 0 0 0 8.5 22H11v-1H8.5A1.5 1.5 0 0 1 7 19.5V17H6zM19.5 7H17V6h2.5A2.5 2.5 0 0 1 22 8.5V11h-1V8.5c0-.83-.67-1.5-1.5-1.5zM22 19.5V17h-1v2.5c0 .83-.67 1.5-1.5 1.5H17v1h2.5a2.5 2.5 0 0 0 2.5-2.5z"
}, null, -1));
const _hoisted_113 = [_hoisted_112];
const _hoisted_114 = {
  class: "segmented"
};
const _hoisted_115 = {
  class: "chart"
};
import { ref, watch } from 'vue';
import store from '@/store';
import { widget } from '../../../public/charting_library';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
export default {
  __name: 'TradingViewKline',
  props: {
    segmentedValue: {
      type: String,
      default: 'Original'
    },
    klineHeight: {
      type: String,
      default: '560px'
    },
    klineActive: {
      type: Number,
      default: 0
    },
    decimal: {
      type: Number,
      default: 2
    },
    klineKey: {
      type: String,
      default: 'BTCUSDT'
    },
    first: {
      type: Boolean,
      default: false
    },
    klineSecond: {
      type: Array,
      default: []
    }
  },
  emits: ['klineMore'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;

    /* eslint-disable */

    dayjs.extend(utc);
    dayjs.extend(timezone);
    const tradingviewResolution = ['1', '5', '15', '30', '60', '1D', '1W', '1M'];
    const chartContainer = ref();
    let chartWidget = ref(null);
    let tvHistoryFunction = ref(null);
    let tvScribeFunction = ref(null);
    let chartData = ref([]);
    const chartType = ref(1);
    let themeName = 'light';
    let changeTheme = null;
    watch(() => store.state.isLight, () => {
      themeName = Boolean(localStorage.getItem('isLight') == 'true') ? 'light' : 'dark';
      changeTheme();
    });
    const tvInit = () => {
      let lang = 'en';
      switch (store.state.lang) {
        case 'tc':
          lang = 'zh_TW';
          break;
        case 'en':
          lang = 'en';
          break;
        case 'hin':
          lang = 'en';
          break;
        case 'fr':
          lang = 'fr';
          break;
        case 'span':
          lang = 'ca_ES';
          break;
        case 'de':
          lang = 'de';
          break;
        case 'it':
          lang = 'it';
          break;
        case 'th':
          lang = 'th';
          break;
        case 'pt':
          lang = 'pt';
          break;
        case 'tr':
          lang = 'tr';
          break;
        case 'kr':
          lang = 'ko';
          break;
        case 'jp':
          lang = 'ja';
          break;
        case 'ru':
          lang = 'ru';
          break;
        case 'ar':
          lang = 'ar';
          break;
      }
      const widgetOptions = {
        symbol: 'BTC',
        datafeed: getDataFeed(),
        interval: [tradingviewResolution[props.klineActive]],
        container: chartContainer.value,
        library_path: '/charting_library/',
        timezone: "America/New_York",
        enabled_features: ['study_templates', "side_toolbar_in_fullscreen_mode",
        //全屏启动工具栏
        'iframe_loading_compatibility_mode' //支持较旧的浏览器和非标准浏览器, 不打开会导致稍微旧版的浏览器打开为空白
        ],

        //功能启用
        disabled_features: ["header_symbol_search", "header_quick_search", "symbol_search_hot_key", "header_compare", "display_market_status",
        //coin状态显示
        "edit_buttons_in_legend",
        //左上角点击
        "go_to_date",
        //跳转时间
        "header_widget" //工具栏
        ],

        //功能禁用
        // charts_storage_url: 'https://saveload.tradingview.com',
        // charts_storage_api_version: '1.1',
        // client_id: 'tradingview.com',
        // user_id: 'public_user_id',
        fullscreen: false,
        autosize: true,
        // debug: true,//控制台信息输出
        overrides: {
          "paneProperties.legendProperties.showVolume": true,
          //是否显示volume
          "paneProperties.legendProperties.showSeriesOHLC": true //是否显示open、high、low...
        },

        time_frames: [],
        //底部时间范围
        custom_formatters: {//时间格式
          // timeFormatter: {
          //     format: function (date) {
          //         let hour = date.getHours();
          //         let minute = date.getMinutes();
          //         hour = hour < 10 ? ('0' + hour) : hour;
          //         minute = minute < 10 ? ('0' + minute) : minute;

          //         return hour + ':' + minute;
          //     }
          // },
          // dateFormatter: {
          //   format: function (date) {

          //     //将这个时间对象更换到纽约时区，不然会导致x轴时间日期错乱
          //     let year = date.getFullYear();
          //     let month = date.getMonth() + 1;
          //     let day = date.getDate();

          //     month = month < 10 ? ('0' + month) : month;
          //     day = day < 10 ? ('0' + day) : day;

          //     console.log(date)

          //     return year + '-' + month + '-' + day;
          //   }
          // }
          // dateFormatter: {
          //   format: function (utcDate) {  // utcDate 是 TradingView 传入的 UTC Date 对象

          //     const timestampMs = utcDate.getTime();

          //     // 转成 dayjs 并切换到纽约时区
          //     const nyDate = dayjs(timestampMs).tz('America/New_York')

          //     // 只取日期部分，格式 YYYY-MM-DD
          //     const formatted = nyDate.format('YYYY-MM-DD')

          //     console.log(timestampMs)
          //     console.log(formatted)

          //     return formatted
          //   }
          // }
        },
        locale: lang,
        //语言
        custom_css_url: 'tradingview.css' //自定义css，放在框架文件夹下的
        // studies_access: {//显示隐藏指定指标
        //     type: "black",
        //     tools: [
        //         {
        //             name: "52 Week High/Low",
        //             grayed: false
        //         }
        //     ]
        // }
      };

      chartWidget.value = new widget(widgetOptions);
      chartWidget.value.onChartReady(() => {
        themeName = Boolean(localStorage.getItem('isLight') == 'true') ? 'light' : 'dark';
        chartWidget.value.changeTheme(themeName).then(() => {
          chartWidget.value.chart().applyOverrides({
            "paneProperties.background": "#141414",
            "paneProperties.backgroundType": 'solid'
          });
          if (themeName == 'light') chartWidget.value.chart().applyOverrides({
            "paneProperties.background": "white",
            "paneProperties.backgroundType": 'solid'
          });
        });
        changeTheme = function () {
          chartWidget.value.changeTheme(themeName).then(() => {
            chartWidget.value.chart().applyOverrides({
              "paneProperties.background": "#141414",
              "paneProperties.backgroundType": 'solid'
            });
            if (themeName == 'light') chartWidget.value.chart().applyOverrides({
              "paneProperties.background": "white",
              "paneProperties.backgroundType": 'solid'
            });
          });
        };
        chartWidget.value.activeChart().setChartType(chartType.value);
        chartWidget.value.headerReady().then(() => {});
      });
    };
    const getDataFeed = () => {
      return {
        onReady: callback => {
          // console.log('[onReady]: Method call');
          setTimeout(() => callback({}));
        },
        resolveSymbol: async (symbolName, onSymbolResolvedCallback, onResolveErrorCallback, extension) => {
          let num = 10;
          for (let i = 1; i < props.decimal; i++) {
            num = num * 10;
          }

          //Coin信息
          const symbolInfo = {
            ticker: store.state.marketInfo[props.klineKey]?.name,
            name: store.state.marketInfo[props.klineKey]?.name + '/USDT',
            description: store.state.marketInfo[props.klineKey]?.name + '/USDT',
            // type: 'crypto',
            session: '24x7',
            // timezone: 'America/New_York',
            // exchange: '',
            minmov: 1,
            pricescale: num,
            //小数位
            has_seconds: true,
            has_intraday: true,
            //设置日内分钟数是否支持，不开启无法实现分钟小时分时图
            has_daily: true,
            has_weekly_and_monthly: true,
            visible_plots_set: 'ohlc',
            supported_resolutions: [tradingviewResolution[props.klineActive]],
            volume_precision: 2,
            //交易量精度
            data_status: 'streaming'
          };
          onSymbolResolvedCallback(symbolInfo);
        },
        getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {
          const {
            firstDataRequest,
            countBack
          } = periodParams;
          try {
            if (props.first == false) {
              //切换指标，更新图表数据什么的必须要对历史回调更新一下，不然指标那会一直在加载
              emit('klineMore');
              // console.log('xxxx')
            }

            //要一直更新，不然onHistoryCallback被调用过就不能再次调用了
            tvHistoryFunction.value = function (data) {
              if (data.result && data.result.length) {
                var arr = [];
                for (var i = 0; i < data.result.length; i++) {
                  var item = data.result[i];
                  arr.push({
                    time: item[0] * 1000,
                    open: Number(item[1]),
                    high: Number(item[3]),
                    low: Number(item[4]),
                    close: Number(item[2]),
                    volume: Number(item[5])
                  });
                }
                arr.push(...chartData.value);
                // chartData = arr

                while (arr.length < countBack) {
                  arr.unshift({
                    time: (Number(arr[0].time / 1000) - Number(props.klineSecond[props.klineActive])) * 1000
                  });
                }
                onHistoryCallback(arr, {
                  noData: false
                });
              } else {
                //tradingview组件第一次请求可能会再次发起请求，如果数据不够会导致第二次进入此处，因此需要传递已有值数组
                var arr = [];
                arr.push(...chartData.value);
                for (let i = 0; i < 300; i++) {
                  arr.unshift({
                    time: (Number(arr[0].time / 1000) - Number(props.klineSecond[props.klineActive])) * 1000
                  });
                }
                // chartData = arr

                // 无数据
                onHistoryCallback(arr, {
                  noData: false
                });
              }
            };
          } catch (error) {
            console.log('[getBars]: Get error', error);
            onErrorCallback(error);
          }
        },
        subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) => {
          tvScribeFunction.value = function (data) {
            if (data.result) {
              onRealtimeCallback({
                time: Number(data.result[0] * 1000),
                open: Number(data.result[1]),
                high: Number(data.result[3]),
                low: Number(data.result[4]),
                close: Number(data.result[2]),
                volume: Number(data.result[5])
              }); // 实时更新塞给tv
            }
          };
        },

        unsubscribeBars: subscriberUID => {}
      };
    };
    expose({
      tvHistoryFunction,
      tvScribeFunction,
      tvInit,
      chartData
    });
    return (_ctx, _cache) => {
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "time")]), _createElementVNode("div", _hoisted_5, [props.segmentedValue == 'TradingView' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_a_dropdown, null, {
        overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
          default: _withCtx(() => [_createVNode(_component_a_menu_item, {
            onClick: _cache[1] || (_cache[1] = $event => {
              _unref(chartWidget).activeChart().setChartType(0);
              chartType.value = 0;
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["chart-icon-item", {
                'choose': chartType.value == 0
              }])
            }, _hoisted_69, 2)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            onClick: _cache[2] || (_cache[2] = $event => {
              _unref(chartWidget).activeChart().setChartType(1);
              chartType.value = 1;
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["chart-icon-item", {
                'choose': chartType.value == 1
              }])
            }, _hoisted_72, 2)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            onClick: _cache[3] || (_cache[3] = $event => {
              _unref(chartWidget).activeChart().setChartType(9);
              chartType.value = 9;
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["chart-icon-item", {
                'choose': chartType.value == 9
              }])
            }, _hoisted_75, 2)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            onClick: _cache[4] || (_cache[4] = $event => {
              _unref(chartWidget).activeChart().setChartType(2);
              chartType.value = 2;
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["chart-icon-item", {
                'choose': chartType.value == 2
              }])
            }, _hoisted_78, 2)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            onClick: _cache[5] || (_cache[5] = $event => {
              _unref(chartWidget).activeChart().setChartType(14);
              chartType.value = 14;
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["chart-icon-item", {
                'choose': chartType.value == 14
              }])
            }, _hoisted_81, 2)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            onClick: _cache[6] || (_cache[6] = $event => {
              _unref(chartWidget).activeChart().setChartType(15);
              chartType.value = 15;
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["chart-icon-item", {
                'choose': chartType.value == 15
              }])
            }, _hoisted_84, 2)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            onClick: _cache[7] || (_cache[7] = $event => {
              _unref(chartWidget).activeChart().setChartType(3);
              chartType.value = 3;
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["chart-icon-item", {
                'choose': chartType.value == 3
              }])
            }, _hoisted_87, 2)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            onClick: _cache[8] || (_cache[8] = $event => {
              _unref(chartWidget).activeChart().setChartType(16);
              chartType.value = 16;
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["chart-icon-item", {
                'choose': chartType.value == 16
              }])
            }, _hoisted_90, 2)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            onClick: _cache[9] || (_cache[9] = $event => {
              _unref(chartWidget).activeChart().setChartType(10);
              chartType.value = 10;
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["chart-icon-item", {
                'choose': chartType.value == 10
              }])
            }, _hoisted_93, 2)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            onClick: _cache[10] || (_cache[10] = $event => {
              _unref(chartWidget).activeChart().setChartType(13);
              chartType.value = 13;
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["chart-icon-item", {
                'choose': chartType.value == 13
              }])
            }, _hoisted_96, 2)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            onClick: _cache[11] || (_cache[11] = $event => {
              _unref(chartWidget).activeChart().setChartType(12);
              chartType.value = 12;
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["chart-icon-item", {
                'choose': chartType.value == 12
              }])
            }, _hoisted_99, 2)]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            onClick: _cache[12] || (_cache[12] = $event => {
              _unref(chartWidget).activeChart().setChartType(8);
              chartType.value = 8;
            })
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(["chart-icon-item", {
                'choose': chartType.value == 8
              }])
            }, _hoisted_102, 2)]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("a", {
          class: "ant-dropdown-link",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, [_createElementVNode("div", _hoisted_6, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_12, 512)), [[_vShow, chartType.value == 0]])]), _createElementVNode("div", _hoisted_13, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_19, 512)), [[_vShow, chartType.value == 1]])]), _createElementVNode("div", _hoisted_20, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_21, _hoisted_26, 512)), [[_vShow, chartType.value == 9]])]), _createElementVNode("div", _hoisted_27, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_30, 512)), [[_vShow, chartType.value == 2]])]), _createElementVNode("div", _hoisted_31, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_32, _hoisted_35, 512)), [[_vShow, chartType.value == 14]])]), _createElementVNode("div", _hoisted_36, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_37, _hoisted_39, 512)), [[_vShow, chartType.value == 15]])]), _createElementVNode("div", _hoisted_40, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_41, _hoisted_43, 512)), [[_vShow, chartType.value == 3]])]), _createElementVNode("div", _hoisted_44, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_45, _hoisted_47, 512)), [[_vShow, chartType.value == 16]])]), _createElementVNode("div", _hoisted_48, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_49, _hoisted_51, 512)), [[_vShow, chartType.value == 10]])]), _createElementVNode("div", _hoisted_52, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_53, _hoisted_55, 512)), [[_vShow, chartType.value == 13]])]), _createElementVNode("div", _hoisted_56, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_57, _hoisted_59, 512)), [[_vShow, chartType.value == 12]])]), _createElementVNode("div", _hoisted_60, [_withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_61, _hoisted_66, 512)), [[_vShow, chartType.value == 8]])])])]),
        _: 1
      }), _createElementVNode("div", _hoisted_103, [(_openBlock(), _createElementBlock("svg", {
        onClick: _cache[13] || (_cache[13] = $event => _unref(chartWidget).chart().executeActionById('insertIndicator')),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        width: "28",
        height: "28",
        fill: "none"
      }, _hoisted_105))])], 64)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_106, [_createElementVNode("div", _hoisted_107, [props.segmentedValue == 'TradingView' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_108, [(_openBlock(), _createElementBlock("svg", {
        onClick: _cache[14] || (_cache[14] = $event => _unref(chartWidget).chart().executeActionById('chartProperties')),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        width: "28",
        height: "28"
      }, _hoisted_110))]), _createElementVNode("div", _hoisted_111, [(_openBlock(), _createElementBlock("svg", {
        onClick: _cache[15] || (_cache[15] = $event => _unref(chartWidget).startFullscreen()),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 28",
        width: "28",
        height: "28"
      }, _hoisted_113))])], 64)) : _renderSlot(_ctx.$slots, "indicator", {
        key: 1
      })]), _createElementVNode("div", _hoisted_114, [_renderSlot(_ctx.$slots, "segmented")])])]), _createElementVNode("div", _hoisted_115, [_withDirectives(_createElementVNode("div", null, [_renderSlot(_ctx.$slots, "chart")], 512), [[_vShow, props.segmentedValue == 'Original']]), _withDirectives(_createElementVNode("div", {
        style: _normalizeStyle({
          height: props.klineHeight,
          width: '100%'
        }),
        class: "TVChartContainer",
        ref_key: "chartContainer",
        ref: chartContainer
      }, null, 4), [[_vShow, props.segmentedValue == 'TradingView']])])]);
    };
  }
};